import script from "./AppCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCard.vue?vue&type=script&setup=true&lang=js"

import "./AppCard.vue?vue&type=style&index=0&id=39c6c4c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c6c4c4"]])

export default __exports__